import axios from 'axios';
import { apiMainUrl } from '../apiConfig';

const API_BASE_URL = apiMainUrl + 'Notifications'; // Adjust the URL based on your actual API's URL

const getNotifications = async (token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch notifications:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

const getUserNotifications = async (token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/userAll`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch notifications:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

const getReadNotifications = async (limit, token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/read`, {
            headers: {
                'Authorization': `Bearer ${token}`
            },
            params: {
                limit
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch unread notifications:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

const getUnreadNotifications = async (token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/unread`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch unread notifications:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

const createNotification = async (formData, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        });
        return response;
    } catch (error) {
        console.error('Failed to create notification:', error);
        return error.response
    }
};


const markAsRead = async (notificationId, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/markAsRead/${notificationId}`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to mark notification as read:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

const getNotificationDetails = async (notificationId, token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/${notificationId}/details`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch notification details with SAS:', error);
        throw error;
    }
};

export const NotificationsDataService = {
    getNotifications,
    getUserNotifications,
    getUnreadNotifications,
    getReadNotifications,
    createNotification,
    markAsRead,
    getNotificationDetails
};
